<template>
  <v-row class="mb-8">
    <v-col 
      cols="12"
      xl="4"
      md="4"
      sm="12"
      v-for="auditorium in auditoriums"
      :key="auditorium.id">

      <v-card
        :loading="loading"
        class="mx-auto"
        max-width="374"
        :to="{ name: 'showAuditorium', params: { auditorium_slug: auditorium.slug } }"
      >
        <v-img
          height="140"
          :src="auditorium.url_miniature"
        ></v-img>

        <v-card-text class="text-center">
          <h3 class="font-weight-regular">{{ auditorium.name }}</h3>
        </v-card-text>

      </v-card>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
      >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'auditoriumEdition',

    data: () => ({
      loading:true,
      loading_btn: false,
      loading_update:false,

      activeChat: true,
      auditoriums:[],
      name:null,

      data:[],

      entrepreneurship:[],

      banner:null,
      url_banner:null,

      miniature:null,
      url_miniature:null,
    }),

    computed: {
      ...mapGetters([
        'edition'
      ])
    },

    methods:{
      async getAuditorium(){
        await axios.get('participant/auditoriums/'+this.edition.edition.id ).then(response =>{
          this.data = response.data.data
          this.auditoriums = response.data.data.auditoriums

          if(this.auditoriums.length==1){
            this.$router.push({ name: 'showAuditorium', params: { auditorium_slug: this.auditoriums[0].slug } })
          }

          this.auditoriums.forEach(element => {
            element.url_miniature = APP_URL + element.miniature
          });
          this.loading = false
        }).catch(error => {
          this.loading = false
          console.log(error);
        })
      },

      showAuditorium(slug){
        alert(slug)
      }
    },

    created(){
       this.edition_id = this.$route.params.edition_id;
       this.auditorium_id = this.$route.params.auditorium_id;
       this.getAuditorium()
    },
  }
</script>
<style>
.images {
  position: fixed;
}
</style>
<style scoped>
.image-banner{
	position: relative;
	width: 100%;
  border-bottom: 5px solid #00a1b8;
}

.contenedor-imagen {
  position: relative;
  display: inline-block; /* O cualquier otro valor que se ajuste a tu diseño */
}


.image-miniature{
	position: relative;
	width: 100%;
  border-radius: 4px;
  border: 1px solid #00a1b8;
  display: block;
}

.section-chat{
  padding-top: 4px;
  position: relative;
	width: 100%;
  min-height:100%;
  border-radius: 4px;
  border: 1px solid #00a1b8;
}
</style>